import React, { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import ForgotForm from "./forgot_form"
import LoginForm from "./login_form"
import RegisterForm from "./register_form"
import { ProfileOutline, CreateAccountOutline } from "@/skylticons"

interface LoginProps {
  admin: boolean
}

const Login: React.FC<LoginProps> = ({ admin }) => {
  const { t } = useTranslation()
  const [forgotPasswordState, setForgotPasswordState] = useState({ open: false, email: "" })

  const showForgotPassword = useCallback((email?: string) => {
    setForgotPasswordState({ open: true, email: email || "" })
  }, [])

  const toggleForgotPassword = useCallback(() => {
    setForgotPasswordState(current => {
      return { ...current, open: !current.open }
    })
  }, [])

  return (
    <div className="pages customerlogin">
      <div className="left-column">
        <div className="loginform">
          <h1 id="already_customer_title" className="heading-three">
            <ProfileOutline />
            {t("customer.already_customer")}
          </h1>
          <div className="forms">
            <LoginForm
              showForgotPassword={showForgotPassword}
              toggleForgotPassword={toggleForgotPassword}
              admin={admin}
            />
            <ForgotForm show={forgotPasswordState.open} email={forgotPasswordState.email} />
          </div>
        </div>
      </div>
      <div className="right-column">
        <div className="registerform">
          <h1 id="new_customer_title" className="heading-three">
            <CreateAccountOutline />
            {t("customer.new_customer")}
          </h1>
          <div className="forms">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
